import { render, staticRenderFns } from "./popup-game-menu.vue?vue&type=template&id=10a1129b&scoped=true&"
import script from "./popup-game-menu.vue?vue&type=script&lang=js&"
export * from "./popup-game-menu.vue?vue&type=script&lang=js&"
import style0 from "./popup-game-menu.vue?vue&type=style&index=0&id=10a1129b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a1129b",
  null
  
)

export default component.exports